import Reveal from './Reveal.jsx';
import { STATS_BAND } from '../data/site.js';

export default function StatsBand() {
  return (
    <div className="stats-band">
      <div className="container">
        <div className="stats-grid">
          {STATS_BAND.map((s, i) => (
            <Reveal className="stat-item" key={s.label} delay={i * 70}>
              <div className="stat-emoji">{s.emoji}</div>
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
